import { render, staticRenderFns } from "./InstructionRedirect.vue?vue&type=template&id=3481d28c&scoped=true&"
import script from "./InstructionRedirect.vue?vue&type=script&lang=js&"
export * from "./InstructionRedirect.vue?vue&type=script&lang=js&"
import style0 from "./InstructionRedirect.vue?vue&type=style&index=0&id=3481d28c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3481d28c",
  null
  
)

export default component.exports